/**
 * List of checklist types
 *
 * @namespace tmrChecklistTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrChecklistTypes',
  {
    ChecklistByUpcDto: 'CHECKLISTTYPES.UPC',
    ChecklistByItemDto: 'CHECKLISTTYPES.ITEM',
  },
]

/**
 * Translates {@link tmrChecklistTypes}
 *
 * @type {ngRun}
 */
let tmrChecklistTypesRun = /*@ngInject*/ (TmrTranslate, tmrChecklistTypes) =>
  TmrTranslate.object(tmrChecklistTypes)

export { tmrChecklistTypesRun as run }
